/**
 * [ File :: B_Solution.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/base/dev/child/attr/B_Solution.js
 * @목적 : 문제를 성공하는 기준을 담고 있는 객체, 해당 객체의 조건이 맞으면 문제가 성공합니다.
 * @진행 : 개발종료
 * @주의 : 없음
 * @이슈 : 없음
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 : 없음
 */

import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder';
import B_Unreal from 'canvas/base/dev/child/base/B_Unreal';
import B_ChildWorld from 'canvas/base/dev/child/base/B_ChildWorld';
import B_Define from 'canvas/base/dev/util/B_Define';
import G_Define from "canvas/grid/dev/util/G_Define";

let mix = (superclass) => new MixinBuilder(superclass);

const B_Solution = (function () {

	/**
	 * [BluePrint]
	 *
	 * # 1. 골 하나 있을 때
	 *      1-1 골에 도착
	 *          t : 도착
	 *          f : 없음 (중도 포기)
	 *      1-2 골에 도착 (아이템 먹고)
	 *          t : 아이템이 있으면 정답 (# 이상의 아이템은? = 실패)
	 *          f : 아이템이 없으면 실패
	 *      1-3 골에 도착 (아이템 놓고)
	 *          t : 아이템이 있으면 정답 (# 상이한 위치? = 실패)
	 *          f : 아이템이 없으면 실패
	 *      1-4 골에 도착 (배열에 넣고)
	 *          t : 배열에 아이템 있으면 정답 (# 추가적으로 있는 아이템은? = 실패)
	 *          f : 배열에 아이템 없음면 실패
	 *      1-5 골에 도착 (아이템 활성화 후에) - 캐릭터 행동
	 *          t : 모든 아이템을 활성화 하고 골에 도착 (# 이상의 행동 = 실패)
	 *          f : 모든 아이템을 활성화 하지 못하고 골에 도착
	 *
	 * # 2. 골 두개 있을 때 (이상)
	 *      2-1 순서가 상관 없을 때
	 *          t : 모든 골에 솔루션에 맞게 클리어 처리
	 *          f : 각각 골에 솔루션에 맞지 않았을 때
	 *      2-2 순서가 상관 있을 때
	 *          t : 순서에 맞게 골에 접근 & 모든 골에 솔루션에 맞게 클리어 처리
	 *          f : 순서에 맞지 않게 골에 접근 & 각각 골에 솔루션에 맞지 않았을 때
	 *
	 * # 3. 상황 처리 (골이 없음)
	 *      3-1 : 바닥의 아이템 먹기
	 *          t : 정답지에 모든 아이템 줍기
	 *          f :
	 *      3-2 : 바닥에 아이템 놓기
	 *          t : 정해진 위치에 모든 아이템 놓기
	 *          f :
	 *      3-3 : 배열에 아이템 넣기
	 *          t :
	 *          f :
	 *      3-4 : 행동 활성화 여부
	 *          t :
	 *          f :
	 *      3-5 : 변수 계산 문제 #
	 *          t :
	 *          f :
	 */

	/**
	 * [SAMPLE]
	 *
	 * G_Solution({
     *      id     : 'solution01',
     *      order  : 1,  (defualt : 0 우선순위없음)
     *      limit  : []  (defualt : null 출입제한없음)
     *      answerSheet : {
     *          inventory : {       // # 1. 캐릭터 소지 아이템
     *              type : "count",         // "count", "weight", ...
     *              expectation : {
     *                  isEntry : false,    // true -> value : number , false -> value : object
     *                  value   : {         // number(array) or object, [0,2] ~> 0~2 개 사이
     *                      item01 : 1,
     *                      item02 : 2
     *                  }
     *              }
     *          }
     *      }
     * })
	 */

	return class extends mix(B_Unreal).with(B_ChildWorld) {

		constructor(obj) {
			super(obj);

			// [S]
			if (obj.order) this._order = obj.order;
			if (obj.limit) this._limit = obj.limit;
			if (obj.answerSheet) this._answerSheet = obj.answerSheet;
			if (obj.success) this._success = obj.success;
		}

		// [V] public

		// @DES :: limit {arr} - 출입제한 (ID)
		get limit () { return this._limit; }
		// set limit(l) { _limit.set(this, l); }

		// @DES :: order {num} - 우선순위
		get order () { return this._order; }
		// set order(o) { _order.set(this, o); }

		// @DES :: anwserSheet {obj} - 정답지 (수정불가)
		get answerSheet () { return JSON.parse(JSON.stringify(this._answerSheet)); }
		// set answerSheet(as) { _answerSheet.set(this, as); }

		// [F] protected

		/**
		 * [ Function :: _compareLimit ]
		 *
		 * @DES :: 출입제한 처리
		 * @IP1 :: strObjectId {str}
		 * @S.E ::
		 */
		_compareLimit (strObjectId) {
			const STATE = this.CODMOS.WORLD.STATE;

			STATE.going(B_Define.CLEAR_STATUS['FAIL'], G_Define.REASON["LIMIT"]); // STOP
			this.limit.forEach((limit) => {
				if (id == limit) STATE.init(); // INIT (pass)
			});
		}

		/**
		 * [ Function :: _compareOrder ]
		 *
		 * @DES :: 우선순위 처리 (우선순위가 나보다 낮은데 클리어 안되있음 => 실패)
		 * @S.E ::
		 */
		_compareOrder () {
			const STATE = this.CODMOS.WORLD.STATE;
			let list = this.CODMOS.WORLD.LIST;

			for (let gKey in list.goal) {

				if (
					list.goal[gKey]._target                    // # 타겟있고
					&&
					list.goal[gKey]._target.order              // # 우선순위 있고
					&&
					this.order > list.goal[gKey]._target.order // # me (2) > target (1)
				) {
					if (!list.goal[gKey].clear) {
						// FAIL !
						STATE.going(B_Define.CLEAR_STATUS['FAIL'], G_Define.REASON["ORDER"]);
					}
				}
			}
		}

		/**
		 * [ Function :: _compareInventory ]
		 *
		 * @DES :: 인벤토리 비교
		 * @IP1 :: hero {obj}
		 * @S.E ::
		 */
		_compareInventory (hero) {

			/**
			 * [STEP]
			 *
			 * 01. 선별 방식 선택 (count, weight)
			 * 02. 전체 부분 여부 확인
			 * 03. 비교
			 * */

			const STATE = this.CODMOS.WORLD.STATE;
			let type = this.answerSheet.inventory.type;                         // 타입
			let isEntry = this.answerSheet.inventory.expectation.isEntry;       // 전체 ? or 부분 ?
			let expectation = this.answerSheet.inventory.expectation.value;     // 기대값

			// # 01.
			switch (type) {
				case "count":
					// # 02.
					if (isEntry) {
						if (!this._equalExpectation(hero.getEntryInventoryCount(), expectation)) {
							STATE.going(B_Define.CLEAR_STATUS['FAIL'], B_Define.REASON["WRONG"]);
						}
					}
					else {
						for (let key in expectation) {
							if (!this._equalExpectation(hero.inventory[key], expectation[key])) {
								STATE.going(B_Define.CLEAR_STATUS['FAIL'], B_Define.REASON["WRONG"]);
							}
						}
					}
					break;
				case "weight":
					// # 02.
					if (isEntry) {
						if (!this._equalExpectation(hero.getEntryInventoryWeight(), expectation)) {
							STATE.going(B_Define.CLEAR_STATUS['FAIL'], B_Define.REASON["WRONG"]);
						}
					}
					else {
						for (let key in expectation) {
							let count = hero.inventory[key];
							let weight = this.getCanvas()._res[key].weight;
							if (!this._equalExpectation((count * weight), expectation[key])) {
								STATE.going(B_Define.CLEAR_STATUS['FAIL'], B_Define.REASON["WRONG"]);
							}
						}
					}
					break;
				default:

					break;
			}
		}

		_compareInventoryNew (hero) {
			return this.answerSheet.inventory.expectation.value === hero.getEntryInventoryCount()
		}

        /**
         * [ Function :: _compareGetValue ]
         *
         * @DES :: 캐릭터 아래 있는 객체의 value와 answerSheet를 비교합니다.
         * @IP1 :: crushObject {obj}
         * @O.P :: null
         */
		_compareGetValue (crushObject) {
			let expectation = this.answerSheet.action.expectation;

			for (const key in expectation) {
				const SOLUTION_VALUE = expectation[key]
				const TARGET_VALUE = crushObject[key] || crushObject['_' + key]
				if (typeof TARGET_VALUE === 'undefined') return true

				return this._equalExpectation(TARGET_VALUE, SOLUTION_VALUE)
			}
		}

        /**
         * [ Function :: _compareSetValue ]
         *
         * @DES :: 오브젝트 값 수정하기 수행 후 캐릭터 아래 있는 객체의 value와 answerSheet를 비교합니다.
         * @IP1 :: value {num}
         * @O.P :: null
         */
		_compareSetValue (value) {
			let solutionValue = this.answerSheet.value.expectation

			if (typeof value === 'undefined') return true

			return this._equalExpectation(value, solutionValue)
		}

        /**
         * [ Function :: _compareValue ]
         *
         * @DES :: 지정된 object들의 value를 비교합니다.
         * @IP1 :: null
         * @O.P :: null
         */
		_compareValue () {
			const EXPECTATION = this.answerSheet.value.expectation
			const STATE = this.CODMOS.WORLD.STATE;

			for (let key in EXPECTATION) {
				if (this._equalExpectation(this.CODMOS.WORLD[key]._value, EXPECTATION[key]) === false) {
					STATE.going(B_Define.CLEAR_STATUS['FAIL'], B_Define.REASON["WRONG_VALUE"]);
					return
				}
			}
		}

        /**
         * [ Function :: _compareVariable ]
         *
         * @DES :: 변수의 값과 answerSheet를 비교합니다.
         * @IP1 :: variable {obj}
         * @IP2 :: value {num}
         * @O.P :: res {bool}
         */
		_compareVariable (variable, value) {
			let expectation = this.answerSheet.variable.expectation;

			if (typeof variable !== 'undefined') {
				// 실시간 처리
				let solutionValue = expectation[variable._id]
				if (typeof solutionValue === 'undefined') return true

				return this._equalExpectation(value, solutionValue)
			} else {
				// goal에서 처리
				const STATE = this.CODMOS.WORLD.STATE;

				for (const key in expectation) {
					let solutionValue = expectation[key]
					const VALUE = this.CODMOS.WORLD[key].value

					if (typeof VALUE === 'undefined' || this._equalExpectation(VALUE, solutionValue)) return true

					STATE.going(B_Define.CLEAR_STATUS['FAIL'], B_Define.REASON["TSV"]);
				}
			}
		}

        /**
         * [ Function :: _compareResource ]
         *
         * @DES :: 해당 리소스를 지닌 오브젝트들의 좌표를 answerSheet와 비교합니다.
         * @IP1 :: null
         * @O.P :: res {bool}
         */
		_compareResource () {
			let expectation = this.answerSheet.res.expectation;
			const OBJECTS = Object.values(this.CODMOS.WORLD.LIST.real)

			return !Object.keys(expectation).some(key => {
				return !OBJECTS.filter(e => e._res === key).some(e => {
					const FIND_INDEX = expectation[key].findIndex(e2 => e._gridX === e2[0] && e._gridY === e2[1])
					if (FIND_INDEX > -1) expectation[key].splice(FIND_INDEX, 1)
					return !expectation[key].length
				})
			})
		}

		_comparePosition () {
			let expectation = this.answerSheet.position.expectation
			const objects = Object.values(this.CODMOS.WORLD.LIST[B_Define.REAL_TYPE])

			return !expectation.some(({ loc, res }) => {
				objects.forEach(({ _res, _gridX: gridX, _gridY: gridY }) => {
					if (
						res.indexOf(_res) > -1
					) {
						const findIndex = loc.findIndex(([x, y]) => x === gridX && y === gridY)
						if (findIndex > -1) loc.splice(findIndex, 1)
					}
				})
				return !!loc.length
			})
		}

		/**
		 * [ Function :: _compareArray ]
		 *
		 * @DES :: 배열 비교
		 * @IP1 :: hero {obj}
		 * @S.E ::
		 */
		_compareArray () {
			/**
			 * [STEP]
			 *
			 * 01. 배열 리스트 조회
			 * 02. 선별 방식 선택 (count, weight)
			 * 03. 전체 부분 여부 확인
			 * 04. 비교
			 * */
			const STATE = this.CODMOS.WORLD.STATE;
			let arr = this.answerSheet.array;

			for (let name in arr) {

				let type = arr[name].type;                              // 타입
				let isEntry = arr[name].expectation.isEntry;            // 전체 ? or 부분 ?
				let expectation = arr[name].expectation.value;          // 기대값
				let targetArray = this.getCanvas().WORLD.LIST.array[name];  // 타켓 배열

				switch (type) {
					case "count":
						if (isEntry) {
							if (!this._equalExpectation(targetArray.getEntryStorageCount(), expectation)) {
								STATE.going(B_Define.CLEAR_STATUS['FAIL'], B_Define.REASON["WRONG"]);
							}
						}
						else {
							let jsonStorage = {};   // Expectation과 비교하기 위해서 임시 비교자를 생생성
							targetArray.getStorage().forEach((v) => {
								let addValue = jsonStorage[v.getRes()] ? jsonStorage[v.getRes()] + 1 : 1;
								jsonStorage[v.getRes()] = addValue;
							});
							// TODO 방식변경 (전체 비교 처리 :: 현재 상관없는 물품이 있어도 클리어)
							for (let key in expectation) {
								if (!this._equalExpectation(jsonStorage[key], expectation[key])) {
									STATE.going(B_Define.CLEAR_STATUS['FAIL'], B_Define.REASON["WRONG"]);
								}
							}
						}
						break;
					case "weight":
						if (isEntry) {
							if (!this._equalExpectation(targetArray.getEntryStorageWeight(), expectation)) {
								STATE.going(B_Define.CLEAR_STATUS['FAIL'], B_Define.REASON["WRONG"]);
							}
						}
						else {
							let jsonStorage = {};   // Expectation과 비교하기 위해서 임시 비교자를 생생성
							targetArray.getStorage().forEach((v) => {
								let addValue = jsonStorage[v.getRes()] ? jsonStorage[v.getRes()] + v.getWeight() : v.getWeight();
								jsonStorage[v.getRes()] = addValue;
							});
							// TODO 방식변경 (전체 비교 처리 :: 현재 상관없는 물품이 있어도 클리어)
							for (let key in expectation) {
								if (!this._equalExpectation(jsonStorage[key], expectation[key])) {
									STATE.going(B_Define.CLEAR_STATUS['FAIL'], B_Define.REASON["WRONG"]);
								}
							}
						}
						break;
					default:

						break;
				}
			}
		}

		/**
		 * [ Function :: _compareGround ]
		 *
		 * @DES :: 바닥 비교
		 * @S.E ::
		 */
		_compareGround (obj) { /*TODO*/ }

		/**
		 * [ Function :: _compareAction ]
		 *
		 * @DES :: 액션 비교
		 * @S.E ::
		 */
		_compareAction (obj) { /*TODO*/ }

		/**
		 * [ Function :: _compareObject ]
		 *
		 * @DES :: 객체 비교
		 * @S.E ::
		 */
		_compareObject (obj) { /*TODO*/ }

		/**
		 * [ Function :: _equalExpectation ]
		 *
		 * @DES :: 기대치와 타켓 비교하기
		 * @IP1 :: targetValue {num}
		 * @IP2 :: solutionValue {arr or num}
		 * @OUT :: rtn {bool}
		 * @S.E ::
		 */
		_equalExpectation (targetValue = 0, solutionValue, ne) {
			let rtn = false

			if (typeof solutionValue === 'number') {
				rtn = targetValue == solutionValue
			} else if (Array.isArray(solutionValue)) {
				solutionValue = solutionValue.map(e => {
					if (e === 'Infinity') return Infinity
					if (e === '-Infinity') return -Infinity
					return e
				})
				rtn =
					ne
						? solutionValue[0] < targetValue && solutionValue[1] > targetValue
						: solutionValue[0] <= targetValue && solutionValue[1] >= targetValue
			}

			return rtn
		}
	}
}());

export default B_Solution;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/attr/B_Solution.js